import { withSvgIcon } from './withSvgIcon';

export const Moon = withSvgIcon(
  <path
    d="M21 12.5835C19.8037 14.7895 17.4676 16.2874 14.7818 16.2874C10.8776 16.2874 7.7127 13.1225 7.7127 9.21832C7.7127 6.53309 9.20987 4.19754 11.415 3.00092C6.71631 3.30704 3 7.21515 3 11.9913C3 16.9672 7.03373 21.0009 12.0096 21.0009C16.7865 21.0009 20.695 17.2833 21 12.5835Z"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinejoin="round"
  />,
  { viewBox: '0 0 24 24' },
);
